<template>
  <div class="booking_results">
    <div class="booking_success" v-if="status === 'success'">
      <img src="../../../assets/Success.png" alt="" />
      <div class="success_text"> {{ $t("message.Booking.results.success") }} </div>
      <div class="success_describe">XXXXXXXXXXXX</div>
    </div>
    <div class="error" v-else-if="status === 'error'">
      <img src="../../../assets/failed.png" alt="" />
      <div class="error_text"> {{ $t("message.Booking.results.error") }} </div>
      <div class="error_describe">
        <div v-if="error">{{ $t("message.Booking.results.reason") }}{{errorCode || (error && error.message) || ''}}</div>
      </div>
    </div>
    <div class="cancel" v-else>
      <img src="../../../assets/Success.png" alt="" />
      <div class="success_text"> {{ $t("message.Booking.results.cancel") }} </div>
      <div class="success_describe"></div>
    </div>
    <div class="button_group">
      <GradientBtn type="primary" @click="$emit('returnBooking')">
        {{ $t("message.Booking.returnBtn") }}
      </GradientBtn>
    </div>
  </div>
</template>

<script>
import GradientBtn from "../../../components/GradientBtn";
export default {
  components: { GradientBtn },
  props: {
    visible: Boolean,
    value: Object,
    status: String,
    errorCode: String,
    error: Object
  },
  data() {
    return {
      pagePath: "add",
      paymentType: "",
    };
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.booking_results {
  min-height: 500px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  margin: auto;
  text-align: center;
  font-size: 24px;
  img {
    width: 120px;
    margin: auto;
  }
  .success_text, .error_text {
    margin: 20px 0;
  }
  .error_describe {
    font-size: 20px;
    color: #9d9d9d;
  }
  .success_describe, .error_describe {
    font-size: 18px;
    margin: 20px 0;
  }
  .button_group {
    margin: 20px auto;
  }
}
</style>